import { render, staticRenderFns } from "./OnboardingKycInformation.vue?vue&type=template&id=c4377304&"
import script from "./OnboardingKycInformation.vue?vue&type=script&lang=js&"
export * from "./OnboardingKycInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports